import { ColorProduct } from 'typescript/components/product_groups/color_product_group';

/**
 * Filters out products that do not have a hexColor or displayName
 * @param products - array of ColorProduct objects
 * @returns array of ColorProduct objects
 */
export const filterInvalidColorProductConfigs = (
  products: ColorProduct[],
): ColorProduct[] => {
  return products.filter((product) => product.hexColor && product.displayName);
};

/**
 * Creates a ColorProduct object from a product object
 * @param product - product object
 * @returns ColorProduct object
 */
export const createColorProductFromProduct = (
  product: Record<string, any>,
): ColorProduct => {
  return {
    name: product.name,
    productKey: product.product_key,
    variantId: product.variant_id,
    slug: product.slug,
    displayName: product?.color?.display_name,
    hexColor: product?.color?.hex_color,
    inStock: !product.shipping.out_of_stock,
  };
};

/**
 * Checks if all products are color grouped
 * @param products - array of Shop products
 * @returns boolean
 */
export const allProductsAreColorGrouped = (
  products: Record<string, any>[],
): boolean => {
  return products.every((product) => product?.product_groups?.color);
};
